<div class="change-main-container flex flex-column gap-3 border-round-xl mt-2">

  <div class="change-pass-head flex gap-2 pb-2 align-items-center ">

    @if(!isFirstTime) {
      <svg-icon key="key" class="text-lg text-primary bg-primary-100 p-2 border-circle">
      </svg-icon>
    }

    <div class="flex flex-column gap-1">
      <div class="m-0 font-semibold text-lg">{{isNewUser ? "Welcome! Lets get started by securing your new account." : "Change password"}}</div>
      <p class="m-0 text-xs font-normal text-gray-500">{{isNewUser ? "You are now few steps closer to explore the magic in finding potential claims. Create you account now." : "Create a secure password"}}</p>
    </div>

  </div>

  <div class="max-w-30rem">
    <form [formGroup]="changePasswordForm">
      <div class="change-pass-form flex flex-column w-full gap-3">
        <div class="flex-1 flex flex-column gap-3">

          @if(!isFirstTime) {
            <div class="flex flex-column flex-1 ">
              <label for="newPassword" class="text-xs font-medium mb-1">Current Password</label>
              <p-password
                formControlName="currentPassword"
                [feedback]="false"
                placeholder="Enter your current password"
                toggleMask="true"
                inputStyleClass="w-full"
                required
              ></p-password>
              <app-form-error-message [formGroup]="changePasswordForm" fieldName="currentPassword" displayName="Current Password" />
            </div>
          }

          <div class="flex flex-column flex-1 ">
            <label for="newPassword" class="text-xs font-medium mb-1">New Password</label>
            <p-password
              formControlName="newPassword"
              [feedback]="false"
              placeholder="Enter your new password"
              toggleMask="true"
              inputStyleClass="w-full"
              required
            ></p-password>
            <app-form-error-message [formGroup]="changePasswordForm" fieldName="newPassword" displayName="New Password" />
          </div>

          @if(changePasswordForm.controls['newPassword'].valid && !isCurrentPasswordEqualsNewPassword()) {
            <div class="flex flex-column flex-1">
              <label for="confirmPassword" class="text-xs font-medium mb-1">Confirm new password</label>
              <p-password
                formControlName="confirmPassword"
                [feedback]="false"
                placeholder="Re-enter your new password"
                toggleMask="true"
                required
              ></p-password>
              <app-form-error-message [formGroup]="changePasswordForm" fieldName="confirmPassword" displayName="Confirm Password" />
            </div>
          }

        </div>
        @if(
          changePasswordForm.controls['newPassword'].dirty &&
          changePasswordForm.controls['newPassword'].hasError('passwordStrength')
        ) {
          <div class="password-policy overflow-hidden ml-1">
            <label class="text-xs font-medium">Must Contain</label>
            <ul class="text-xs">
              @for (policy of passwordPolicy; track $index) {
              <li
                class="password-policy-requirements"
                [ngClass]="{ 'password-error': policy.isPassed === false && changePasswordForm.dirty && changePasswordForm.controls['newPassword'].value === ''}"
              >
                <div
                  class="password-policy-check-icon"
                  [ngClass]="policy.isPassed == true ? 'green' : 'default'"
                >
                  @if(policy.isPassed === true) {
                    <i class="pi pi-check-circle"></i>
                  } @else {
                    <i class="pi pi-times-circle"></i>
                  }
                </div>
                <div class="password-policy-text">{{ policy.displayName }}</div>
              </li>
              }
            </ul>
          </div>
        } @else if(changePasswordForm.controls['newPassword'].valid && isCurrentPasswordEqualsNewPassword()) {
          <div class="text-xs p-error">Current password and new password should not be same</div>
        } @else if(changePasswordForm.controls['newPassword'].valid && changePasswordForm.controls['confirmPassword'].touched && !checkPasswordMatch()) {
          <div class="text-xs p-error">Password did not match</div>
        } @else if(changePasswordForm.controls['newPassword'].valid && checkPasswordMatch()) {
          <div class="text-xs text-green-500">Password matched</div>
        }


        <div class="align-self-center mt-2 w-full">
          <button
          pButton
            class="btn btn-primary text-xs w-full"
            (click)="changePassword()"
            [disabled]="changePasswordForm.invalid || !checkPasswordMatch() || isChangingPassword || isCurrentPasswordEqualsNewPassword()"
          >
            <span *ngIf="!isChangingPassword">{{isNewUser ? "Create password" : "Change password"}}</span>
            <span *ngIf="isChangingPassword">
              <i class="pi pi-spin pi-spinner mr-3"></i>{{isNewUser ? "Creating password" : "Changing password"}}</span>
          </button>

        </div>
      </div>
    </form>
  </div>
</div>
